import phoneImage from "../../assets/images/illustration-phones.svg";
export default function Infrastructure() {
  return (
    <section className="flex flex-wrap justify-center px-2 pt-10 pb-2 text-center bg-blue-900 rounded-bl-big rounded-tr-big tablet:flex-row desktop:">
      <div>
        <img src={phoneImage} alt="" className="relative tablet" />
      </div>

      <div className="desktop:px-10">
        <h2 className="py-2 text-2xl font-semibold text-white">
          State of the Art Infrastructure
        </h2>
        <p className="pt-2 pb-24 text-white">
          {" "}
          With reliability and speed in mind, worldwide data centers provide the
          backbone for ultra-fast connectivity. This ensures your site will load
          instantly, no matter where your readers are, keeping your site
          competitive.
        </p>
      </div>
    </section>
  );
}
